import React from 'react'
import PropTypes from 'prop-types'
import File from './File'
import { Processing } from '../Processing'
import { ITEM_CONTENT_ACTIONS } from 'shared/constants'
import isEqual from 'lodash/isEqual'

class FileContainer extends React.Component {
  _isMounted = false

  constructor(props) {
    super(props)

    this.state = {
      previewMetadata: null,
      isProcessing: true
    }
  }

  componentDidMount() {
    this._isMounted = true
    this.handleNewItem()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  componentDidUpdate(prevProps) {
    !isEqual(prevProps.contentItemId, this.props.contentItemId) && this.handleNewItem()
  }

  handleNewItem = () => {
    this.setState({ previewMetadata: null, isProcessing: true })

    this.props.onItemContentAction(
      ITEM_CONTENT_ACTIONS.getFileMetadata,
      { contentItemId: this.props.contentItemId }
    )
      .then((response) => {
        this._isMounted && this.setState({ previewMetadata: response.preview_metadata, isProcessing: false })
      })
  }

  render() {
    if(this.state.isProcessing) {
      return <Processing />
    }
    else {
      return this.state.previewMetadata ? (
        <File
          item={this.props.item}
          previewMetadata={this.state.previewMetadata} />
      ) : (
        <div><h3>Item is not for view api</h3></div>
      )
    }
  }
}

FileContainer.propTypes = {
  item: PropTypes.object.isRequired
}

export default FileContainer
